import { jsx as e } from "react/jsx-runtime";
//#region lib/Table/components/TableRow.tsx
var t = ({ children: t, attributes: n }) => /* @__PURE__ */ e("tr", {
	...n,
	children: t
});
t.displayName = "TableRow";
//#endregion
export { t as TableRow };
